import React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { InHomeUtils } from './../util/inhomeUtils';
import StudentDisclaimers from "../constants/studentDisclaimers.json";

const STUDENT_DISCOUNT_PROMO = "PR10008416~OF10042288";
const YOUTUBE_TV_DISCLAIMER = "\u003Cp\u003E\u003Cp\u003E\u003Cb\u003EYouTube TV:\u003C/b\u003E Must be 18 years or older. Valid form of payment required. Standard subscription price (currently $82.99/mo.) after trial. YouTube TV offer is redeemable where YouTube TV is available. For more information and dates of offer, see \u003Ca href=\"https://tv.youtube.com/learn/offer-terms/\" title=\"https://tv.youtube.com/learn/offer-terms/\"\u003Ehttps://tv.youtube.com/learn/offer-terms/\u003C/a\u003E. Additional terms apply.\u003C/p\u003E\u003C/p\u003E\n";

class promoDisclaimer extends React.PureComponent {

    getStudentDisclaimer(promo) {
        let disclaimer = "";
        try {
            const promoArray = promo?.split("~");
            const selectedInternet = this.props.buildProductState?.internet?.selectedProduct
            const cartInternet = this.props.cart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName?.toLowerCase() === "service")?.subSections?.subSection?.find(s => s?.sectionType === "DATASTANDALONE")?.products?.[0];
            const profileInternet = this.props.profileCart?.cartResponse?.tierContent?.[0]?.sections?.section?.find(s => s?.sectionName?.toLowerCase() === "service")?.subSections?.subSection?.find(s => s?.sectionType === "DATASTANDALONE")?.products?.[0];
            const studentInternet = StudentDisclaimers["internet"][(selectedInternet?.id || cartInternet?.prodId || profileInternet?.prodId)];
            if (studentInternet?.disclaimer && studentInternet?.promoid === promoArray?.[0] && studentInternet?.offerid === promoArray?.[1]) {
                disclaimer = studentInternet?.disclaimer;
            }
        } catch (e) {
            console.error(e);
        }
        return disclaimer;
    }

    render() {

        let channelDisclaimer = '';
        let routerDisclaimer = '';
        let profileDisneyDisclaimer='';
        let profileInternetDisclaimer='';
        let mobileDisclaimers='';
        let internetDisclaimer = '';
        let youTubeTVDisclaimer = '';
        let slingTVDisclaimer = '';
        let tvDisclaimer = '';
        let voiceDisclaimer = '';
        let promotionDisclaimer = '';
        let streamTvDisclaimer = '';
        let rewardsDisclaimer = '';
        let rewardOffer = "";
        let promotionList = "";
        let arrPromotions = [];
        let arrRewardOffers = [];
        let fcpProductDisclaimer = "";
        let fcpProductLists = "";
        let fcpEquipProductLists = "";
        let mnhEligibileDiscount = "";
        let arrFcpProduct = [];
        let homeSecurityDesc = "";
        let homeSecureplusDesc = "";
        let homeSecureDesc = "";
        //let fcpProductsWithDisclaimer = 'Q7818|Q8337';
        let MFRTEligible = this.props.MFRTEligible || null;
        let YouTubeEligible = this.props.YouTubeEligible || null;
        let SlingEligible = this.props.SlingEligible || null;
        let isHomeSecuirtyAdded = this.props.isHomeSecurityAdded || false;
        let isHomeSecurePlusAdded = this.props.isHomeSecurePlusAdded || false;
        let isHomeSecureAdded = this.props.isHomeSecureAdded || false;

        let splitBillTab = this.props.cart.splitBillTab;
        let isCartDataEmpty = (InHomeUtils.isNotNull(this.props.cart.cartData) && this.props.cart.cartData.length !== 0) ? true : false
        let mfrt1GigDisc = '';
        let hoaFlow = InHomeUtils.isNotNull(this.props.hoaFlow) && this.props.hoaFlow;
        let mfrt75MDisc = '';
        let mfrtOtherDisc = '';
        let isIONT = (this.props.loopQual && this.props.loopQual.lqQualdetails && 
        this.props.loopQual.lqQualdetails.getBroadbandAvailabilityResult && 
        this.props.loopQual.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR &&
        this.props.loopQual.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent &&
        this.props.loopQual.lqQualdetails.getBroadbandAvailabilityResult.fttpAvailabilityDetailsAGR.isInActiveONTPresent == "Y")|| (this.props.cart?.iONTEligibleAmazon) ? true : false;
        let atvQual = this.props.cart && this.props.cart?.atvQual ? true : false; 
        let isAndroidTVSTB = this.props.buildProductState && this.props.buildProductState.tv && (this.props.buildProductState.tv.QAMEligible || this.props.buildProductState.tv.streamTvEligible || this.props.buildProductState.tv.AndriodUpgradeEligible) ? true : false;
        let mm3Qualified = this.props.buildProductState && this.props.buildProductState?.internet && this.props.buildProductState?.internet?.mm3Qualified ? true : false;
        let disneyProfileDisclaimer = false
        let disneyOnProfile = this.props.profileCart && this.props.profileCart.cartData && this.props.profileCart.cartData[0]&& this.props.profileCart.cartData[0]?.streamService && this.props.profileCart.cartData[0]?.streamService?.streamServiceProds?.filter(item => item.prodTypeVal==='DISNEYPLUS').length >0 ? true : false
        let mnhSignupIndicator = this.props.internetProductContent && this.props.internetProductContent?.mnhSignupIndicator === "N";
        let isMnhDiscountEligible = this.props.cart && this.props.cart.cartData && this.props.cart.cartData[0] && this.props.cart.cartData[0]?.rewardOffers && this.props.cart.cartData[0]?.rewardOffers?.rewardOffers?.filter((item)=> item.offerAttrValue?.indexOf('MnM3_60M') > -1).length>0;
        let internetOnProfile = this.props.profileCart && this.props.profileCart.ProfileDataProduct && this.props.profileCart.ProfileDataProduct.prodId && this.props.profileCart.ProfileDataProduct?.prodId === "R1654";
        let isgigAvailable = InHomeUtils.isNotNull(this.props.buildProductState) && InHomeUtils.isNotNull(this.props.buildProductState.internet) && InHomeUtils.isNotNull(this.props.buildProductState.internet.m2mPlans) ? this.props.buildProductState.internet.m2mPlans.filter(v => v.speedCode === "941").length > 0 : false;
        const ytInCart = this.props.cart && this.props?.cart?.cartData && this.props?.cart?.cartData?.[splitBillTab] && this.props?.cart?.cartData?.[splitBillTab]?.streamService?.streamServiceProds?.find(prod => prod?.prodTypeVal === 'YOUTUBE');
        const ytInProfile = this.props?.profileCart?.cartData?.[splitBillTab]?.streamService?.streamServiceProds?.find?.(prod => prod?.prodTypeVal === 'YOUTUBE');
        let isDisclaimerPresent = ["R3584","R3585","R3587","R3586","R3583","R3582"].findIndex(value => value === this.props?.buildProductState?.internet?.selectedProduct?.id) < 0 ;
        if (InHomeUtils.isNotNull(this.props.selectedServices) && InHomeUtils.isNotNull(this.props.commonDisclaimer) && InHomeUtils.isNotNull(this.props.commonDisclaimer.items) && this.props.commonDisclaimer.items.length > 0) {
            this.props.commonDisclaimer.items.map(e => {
                switch (e.productid) {
                    case 'Router':
                        if ((this.props.selectedServices.isInternet || this.props.selectedServices.isTv) && !hoaFlow) {
                            routerDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'Data':
                        if (this.props.selectedServices.isInternet) {
                            internetDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'mfrtDataGig':
                        mfrt1GigDisc = e.disclaimer; break;
                    case 'mfrtData75M':
                        mfrt75MDisc = e.disclaimer; break;
                    case 'mfrtDataOther':
                        mfrtOtherDisc = e.disclaimer; break;
                    case 'YouTube TV':
                        if ((YouTubeEligible || ytInCart || ytInProfile) && !hoaFlow) {
                            youTubeTVDisclaimer = e.disclaimer;
                        }
                        break;
                    
                    case 'SlingTV':
                        if (this.props.selectedServices.isSlingTV || SlingEligible) {
                            slingTVDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'TV':
                        if (this.props.selectedServices.isTv) {
                            tvDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'Channel':
                        if (this.props.selectedServices.isTv && !hoaFlow) {
                            channelDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'InternationalChannel':
                        if (this.props.selectedServices.isTv) {
                            channelDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'StreamTV':
                        if (this.props.selectedServices.isTv && !hoaFlow) {
                            streamTvDisclaimer = e.disclaimer;
                        }
                        break;
                    case 'Voice':
                        if (this.props.selectedServices.isVoice) {
                            voiceDisclaimer = e.disclaimer;
                        }
                        break;
                }
            });
            if (MFRTEligible) {
                if (this.props.selectedServices.isDataGig) {
                    internetDisclaimer += mfrt1GigDisc;
                }
                if (this.props.selectedServices.isData75M) {
                    internetDisclaimer += mfrt75MDisc
                }
                if (this.props.selectedServices.isDataNotGig) {
                    internetDisclaimer += mfrtOtherDisc
                }
            }
        }
        else if (InHomeUtils.isNotNull(this.props.selectedServices) && InHomeUtils.isNotNull(this.props.commonDisclaimer)) {
            if (this.props.selectedServices.isInternet || this.props.selectedServices.isTv) {
                if (InHomeUtils.isNotNull(this.props.commonDisclaimer.Router) && InHomeUtils.isNotNull(this.props.commonDisclaimer.Router.disclaimer) && !hoaFlow) {
                    routerDisclaimer = this.props.commonDisclaimer.Router.disclaimer;
                }

                if (this.props.selectedServices.isInternet) {
                    if (InHomeUtils.isNotNull(this.props.commonDisclaimer.Data) && InHomeUtils.isNotNull(this.props.commonDisclaimer.Data.disclaimer)) {
                        internetDisclaimer = this.props.commonDisclaimer.Data.disclaimer;
                    }
                    
                    // if ((this.props.selectedServices.isYouTubeTV || YouTubeEligible) &&  InHomeUtils.isNotNull(this.props.commonDisclaimer.YouTubeTV)){
                    //     youTubeTVDisclaimer = this.props.commonDisclaimer.YouTubeTV.disclaimer;
                    // }
                    if (MFRTEligible) {
                        if (this.props.selectedServices.isDataGig) {
                            internetDisclaimer += this.props.commonDisclaimer.mfrtDataGig.disclaimer;
                        }
                        if (this.props.selectedServices.isData75M) {
                            internetDisclaimer += this.props.commonDisclaimer.mfrtData75M.disclaimer;
                        }
                        if (this.props.selectedServices.isDataNotGig) {
                            internetDisclaimer += this.props.commonDisclaimer.mfrtDataOther.disclaimer;
                        }
                    }

                }
                if (this.props.selectedServices.isTv) {
                    /* CETC-146172 : YTTV is not in buildProduct state and hence disclaimer is empty but it is in cart(on profile / while moving), then need to show disclaimer */
                    if ((this.props.selectedServices.isYouTubeTV || YouTubeEligible || ytInCart || ytInProfile) && InHomeUtils.isNotNull(this.props.commonDisclaimer.YouTubeTV)) {
                        youTubeTVDisclaimer = this.props.commonDisclaimer.YouTubeTV.disclaimer;
                    } else if (this.props.selectedServices.isYouTubeTV || YouTubeEligible || ytInCart || ytInProfile) {
                        youTubeTVDisclaimer = YOUTUBE_TV_DISCLAIMER;
                    }
                    if (SlingEligible && InHomeUtils.isNotNull(this.props.commonDisclaimer.SlingTV)) {
                        slingTVDisclaimer = this.props.commonDisclaimer.SlingTV.disclaimer;
                    }
                    if (InHomeUtils.isNotNull(this.props.commonDisclaimer.Channel) && InHomeUtils.isNotNull(this.props.commonDisclaimer.Channel.disclaimer) && !hoaFlow) {
                        channelDisclaimer = this.props.commonDisclaimer.Channel.disclaimer;
                    }
                    if (InHomeUtils.isNotNull(this.props.commonDisclaimer.TV) && InHomeUtils.isNotNull(this.props.commonDisclaimer.TV.disclaimer)) {
                        tvDisclaimer = this.props.commonDisclaimer.TV.disclaimer;
                    }
                    if (InHomeUtils.isNotNull(this.props.commonDisclaimer.StreamTV) && InHomeUtils.isNotNull(this.props.commonDisclaimer.StreamTV.disclaimer)) {
                        streamTvDisclaimer = this.props.commonDisclaimer.StreamTV.disclaimer;
                    }
                }
            }

            if (this.props.selectedServices.isVoice) {
                if (InHomeUtils.isNotNull(this.props.commonDisclaimer.Voice) && InHomeUtils.isNotNull(this.props.commonDisclaimer.Voice.disclaimer)) {
                    voiceDisclaimer = this.props.commonDisclaimer.Voice.disclaimer;
                }
            }
        }
        if (!youTubeTVDisclaimer && ((!ytInProfile?.price && ytInCart?.price) || (ytInProfile?.price))) {
            youTubeTVDisclaimer = YOUTUBE_TV_DISCLAIMER.replace("$82.99", (ytInCart?.price || ytInProfile?.price || "$82.99"));
        }

        let cartEmpty = this.props.cart && this.props.cart?.cartResponse && this.props.cart?.cartResponse?.tierContent && this.props.cart?.cartResponse?.tierContent[0] 
        && this.props.cart?.cartResponse?.tierContent[0]?.sections && this.props.cart?.cartResponse?.tierContent[0]?.sections?.section && this.props.cart?.cartResponse?.tierContent[0]?.sections?.section?.length == 0 ? true: false;
        let cartServices = this.props.cart && this.props.cart.cartData && this.props.cart.cartData[splitBillTab];
        let profileServices = this.props.profileCart && this.props.profileCart.cartData && this.props.profileCart.cartData[splitBillTab];
        let finalDiscServices = ''
        if (InHomeUtils.isNotNull(cartServices)) {
            finalDiscServices = cartServices
        } else {
            finalDiscServices = profileServices
            disneyProfileDisclaimer = true;
        }

        if (this.props.appState?.flowType === "AF" && cartEmpty){
            finalDiscServices = profileServices
            disneyProfileDisclaimer = true;
        }

        if (splitBillTab === 0 && InHomeUtils.isNotNull(finalDiscServices)) {
            let rewardOffers = (InHomeUtils.isNotNull(finalDiscServices.rewardOffers) && InHomeUtils.isNotNull(finalDiscServices.rewardOffers.rewardOffers)
                && InHomeUtils.isNotNull(finalDiscServices.rewardOffers.rewardOffers)) ? finalDiscServices.rewardOffers.rewardOffers : "";
            if (rewardOffers.length > 0) {
                rewardOffer = finalDiscServices.rewardOffers.rewardOffers.map((promo, index) => {
                    if (promo && promo.promoText.indexOf("AMC+") > -1 && (this.props.selectedServices.isDataGig || this.props.selectedServices.isDataMaxSpeed)) {
                        //promo.promotionId=`${promo.promotionId}_Gig`;
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig' + '~' + promo.offerId : promo.offerId
                    }
                    else {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }
                })
            }
            if (rewardOffers.length > 0) {
                rewardOffer = finalDiscServices.rewardOffers.rewardOffers.map((promo, index) => {
                    if (promo && promo.promoText.indexOf("One Month of Fios Data Service On Us") > -1 && (this.props.selectedServices.isDataGig || this.props.selectedServices.isDataMaxSpeed)) {
                        //promo.promotionId=`${promo.promotionId}_Gig`;
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig' + '~' + promo.offerId : promo.offerId
                    }
                    else if (promo && promo.promoText.indexOf("One Month of Fios Data Service On Us") > -1 && (this.props.selectedServices.isData400M || this.props.selectedServices.isData500M)) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_mid' + '~' + promo.offerId : promo.offerId
                    }

                    else {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }
                })
            }

            if (rewardOffers.length > 0) {
                rewardOffer = finalDiscServices.rewardOffers.rewardOffers.map((promo, index) => {
                    if (promo && promo.promoText.indexOf("$20 Special Ongoing Discount") > -1 && (this.props.selectedServices.isData2G || this.props.selectedServices.isDataMaxSpeed)) {
                        //promo.promotionId=`${promo.promotionId}_Gig`;
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G' + '~' + promo.offerId : promo.offerId
                    }

                  else if (promo && promo.promoText.indexOf("$20 Special Ongoing Discount") > -1 && (this.props.selectedServices.isDataGig || this.props.selectedServices.isDataMaxSpeed)) {
                        //promo.promotionId=`${promo.promotionId}_Gig`;
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig' + '~' + promo.offerId : promo.offerId
                    }
                    else if (promo && promo.promoText.indexOf("$20 Special Ongoing Discount") > -1 && (this.props.selectedServices.isData400M || this.props.selectedServices.isData500M)) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_mid' + '~' + promo.offerId : promo.offerId
                    }

                    else {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }
                })
            }

            if (rewardOffers.length > 0) {
                rewardOffer = finalDiscServices.rewardOffers.rewardOffers.map((promo, index) => {
                    if (promo && promo.promoText.indexOf("Mobile + Fios $200 Verizon Gift Card") > -1 && (this.props.selectedServices.isData2G || this.props.selectedServices.isDataGig || this.props.selectedServices.isData500M || this.props.selectedServices.isData300M)) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }else if(promo && promo.promoText.indexOf("$20 Special Ongoing Discount") > -1 && this.props.selectedServices.isDataGig){
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig~' + promo.offerId : promo.offerId
                    }else if(promo && promo.promoText.indexOf("$20 Special Ongoing Discount") > -1 && (this.props.selectedServices.isData500M || this.props.selectedServices.isData300M)){
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_mid~' + promo.offerId : promo.offerId
                    }else if(promo && (promo.promoText.indexOf("Xbox Series S Console") > -1 || promo.promoText.indexOf("Xbox Stereo Headset") > -1) && this.props.selectedServices.isData2G){
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo.promoText.indexOf("Walmart+ on us for 12 months") > -1) && this.props.selectedServices.isData2G) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo.promoText.indexOf("$20 Ongoing Fios Internet Discount") > -1) && this.props.selectedServices.isData2G) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo.promoText.indexOf("$20 Ongoing Fios Internet Discount") > -1) && this.props.selectedServices.isDataGig) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo.promoText.indexOf("One Month of Fios Data Service On Us") > -1) && this.props.selectedServices.isData2G) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo.promoText.indexOf("One Month of Fios Data Service On Us") > -1) && this.props.selectedServices.isDataGig) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig~' + promo.offerId : promo.offerId
                    }
                    else{
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }
                })
            }

            if (InHomeUtils.isNotNull(finalDiscServices.serviceHeaders) && InHomeUtils.isNotNull(finalDiscServices.serviceHeaders.servicehead)) {

                fcpProductLists = finalDiscServices.serviceHeaders.servicehead.map((prod, index) => {
                    if (prod.prodType === 'FTTPD') {

                        if (this.props.vintageOfferQualified)
                            return `${prod.speedCode}_VINTAGE`;
                        // else if (this.props.cart.isIONT || this.props.SOCNOCQual)
                        else if (this.props.internetProductContent && this.props.internetProductContent.mnhSignupIndicator === 'Y') {
                                let mnh10$ = this.props.cart && this.props.cart.cartData && this.props.cart.cartData[0] && this.props.cart.cartData[0].Promotions && this.props.cart.cartData[0].Promotions.promotions.filter((promo)=>  promo.offerAttrValue.indexOf('MF2DISCF10') > -1).length > 0;
                                let mnh15$ = this.props.cart && this.props.cart.cartData && this.props.cart.cartData[0] && this.props.cart.cartData[0].Promotions && this.props.cart.cartData[0].Promotions.promotions.filter((promo)=>  promo.offerAttrValue.indexOf('MF2DISCF15') > -1).length > 0;
                                let mnh25$ = this.props.cart && this.props.cart.cartData && this.props.cart.cartData[0] && this.props.cart.cartData[0].Promotions && this.props.cart.cartData[0].Promotions.promotions.filter((promo)=>  promo.offerAttrValue.indexOf('MF2DISCF25') > -1).length > 0;
                                
                                if (this.props.loopQual && this.props.loopQual.runtimeKey && this.props.loopQual.runtimeKey.mnhJointOffer && this.props.loopQual.runtimeKey.mnhJointOffer === "Y") {
                                    if ( (mnh10$ && !mnh15$)|| (mnh10$ && mnh15$)|| mnh25$ ) {
                                        return `${prod.speedCode}_MNHJOINT`;
                                    }
                                }
                                else if (this.props.loopQual && this.props.loopQual.runtimeKey && this.props.loopQual.runtimeKey.mnhJointOffer && this.props.loopQual.runtimeKey.mnhJointOffer === "N") {
                                    if (mnh10$) {
                                        if (isIONT){
                                            return `${prod.speedCode}_MNHNONPM_IONT`
                                        }
                                        else{
                                            return `${prod.speedCode}_MNHNONPM`;
                                        }
                                    }
                                    else if (mnh25$) {
                                        if (isIONT){
                                            return `${prod.speedCode}_MNHPM_IONT`;
                                        }
                                        else{
                                            return `${prod.speedCode}_MNHPM`;
                                        }
                                    }
                                }
                            
                        }
                        else if (!this.props.loopQual?.isFCPflow || (this.props.appState?.flowType == "AF" && !mm3Qualified)){
                            if (isIONT){
                                return `${prod.speedCode}_IONT_CLASSIC`
                            }
                            else{
                                return `${prod.speedCode}_CLASSIC`;
                            }
                        }
                        else if (isIONT){
                            if(this.props.maxSpeedCode != undefined && this.props.maxSpeedCode != null && this.props.maxSpeedCode === "940"){
                                return `${prod.speedCode}_IONT_NONGIG`;
                            }
                            else{
                                return `${prod.speedCode}_IONT`;
                            }
                        }
                        else if((this.props.maxSpeedCode != undefined && this.props.maxSpeedCode != null && this.props.maxSpeedCode === "940") || (!isgigAvailable)){
                            return `${prod.speedCode}_NONGIG`;
                        }
                         else {
                            let finalSpeedCode = ""
                            if (prod.speedCode == 0 && prod.prodId == "R0722") {
                                finalSpeedCode = 947
                            }
                            else if(prod.speedCode == 0 && prod.prodId == "R0370") {
                                finalSpeedCode = 939
                            }
                             else {
                                finalSpeedCode = prod.speedCode
                            }
                            return `${finalSpeedCode}`;
                        }
                    }
                    else if ((prod.prodType === 'BASIC' || prod.prodType === 'BASICDIFF') && (prod.prodTypeValue || prod.prodTypeVal))
                        return prod.prodTypeVal ? prod.prodTypeVal : prod.prodTypeValue;
                    else
                        return prod.prodId;
                })
            }
            if (InHomeUtils.isNotNull(finalDiscServices.equipments) && InHomeUtils.isNotNull(finalDiscServices.equipments.equipment)) {
                fcpEquipProductLists = finalDiscServices.equipments.equipment.map((prod, index) => {
                    if (prod.prodType === "ROUTERBILLER") {
                        routerDisclaimer = "";
                        return prod.prodId;
                    }
                    if (prod.prodType === "VROOM" && (isAndroidTVSTB || atvQual)) {
                        return prod.prodType;
                    }
                })
            }

            let promotionLists = (InHomeUtils.isNotNull(finalDiscServices.Promotions) && InHomeUtils.isNotNull(finalDiscServices.Promotions.promotions)
                && InHomeUtils.isNotNull(finalDiscServices.Promotions.promotions)) ? finalDiscServices.Promotions.promotions : "";
            if (promotionLists.length > 0) {
                promotionList = finalDiscServices.Promotions.promotions.map((promo, index) => {
                    if (promo && (promo?.promoText?.indexOf("$20 Ongoing Fios Internet Discount") > -1) && this.props.selectedServices?.isData2G) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_2G~' + promo.offerId : promo.offerId
                    }
                    else if (promo && (promo?.promoText?.indexOf("$20 Ongoing Fios Internet Discount") > -1) && this.props.selectedServices?.isDataGig) {
                        return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '_Gig~' + promo.offerId : promo.offerId
                    }
                    else{
                    return InHomeUtils.isNotEmpty(promo.promotionId) ? promo.promotionId + '~' + promo.offerId : promo.offerId
                    }
                })
            }
        }
        let router = this.props.cart.cartResponse?.tierContent?.[0]?.sections?.section?.[1]?.subSections?.subSection?.[0]?.products?.[0]?.prodId
        console.log(router,this.props.cart.cartResponse,'router add check')
        if (promotionList.length > 0) {
            promotionList.forEach(promo => {
                if (InHomeUtils.isNotNull(this.props.buildProductContent[promo]) && InHomeUtils.isNotEmpty(this.props.buildProductContent[promo].disclaimer) && !(promo?.includes("OF10043059") || promo?.includes("OF10043010"))) {
                    if(router === 'R1739' && promo === 'PR10008306~OF10042175') {
                        arrPromotions.push(this.props.buildProductContent['PR10008313~OF10042180'].disclaimer); 
                    } else {
                        arrPromotions.push(this.props.buildProductContent[promo].disclaimer);                   
                    }
                    
                }
            });
            console.log(this.props.cart?.cartData?.[0]?.Promotions?.promotions?.[0]?.price,this.props,'test path')
            let price = this.props.cart?.cartData?.[0]?.Promotions?.promotions?.find((offertxt)=>offertxt?.offerAttrValue==="MF4DISCF15")?.price;
        //     if(this.props?.cart?.cartData?.[0]?.Promotions?.promotions?.find((offertxt)=>offertxt?.offerAttrValue==="MF4DISCF15")?.price) {
        //         arrPromotions.push('<p><b>Mobile + Home $'+ parseInt(price)+' Discount:</b> Get both Verizon mobile and Fios Home Internet services, and you can get our best savings. When you have both services and enroll in the Mobile + Home Discount, you qualify for discounted pricing:<br><br><ul><li>If you have mobile service and add Fios Home Internet, you can get a disocount on your Fios bill.</li><li>If you have Fios Home Internet and add an eligible mobile plan, you can get a dicount on your mobile bill.</li><li>Already have both? You may still qualifuy for a discount on one of your bills.</li></ul>')
        // }
        let prdName= this.props.cart?.cartData?.[0]?.serviceHeaders?.servicehead?.[0]?.prodName;
        let prdPrice=this.props.cart?.cartData?.[0]?.serviceHeaders?.servicehead?.[0]?.price;
        let prdId=this.props.cart?.cartData?.[0]?.serviceHeaders?.servicehead?.[0]?.prodId;
        let cprdPrice=parseFloat(prdPrice?.replace(/[^0-9.]/g,""));
        cprdPrice=Math.round(cprdPrice);
        if(this.props?.loopQual?.runtimeKey?.PriceGuarantee == 'Y'){
            if(prdId === 'R3584' || prdId === 'R3585'){
                arrPromotions?.push('<p><b>Fios:</b> Fios ' +prdName+' plan at $' +parseInt(cprdPrice)+'/mo when combined with postpaid Verizon mobile phone plan (excludes business and data-only plans). Auto Pay & paper-free billing req’d. Mobile + Home Discount enrollment req’d. $99 setup and other terms apply. Availability varies. Subject to credit approval. Wired and wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com/yourspeed for more info. <b>4-year price lock guarantee:</b> For new Verizon Home Internet ("VHI") households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts or promotion, plan perk and any other third-party services.')
            }
            else if(prdId === 'R3587' || prdId ==='R3586'){
                arrPromotions?.push('<p><b>Fios:</b> Fios ' +prdName+' plan at $' +parseInt(cprdPrice)+'/mo when combined with postpaid Verizon mobile phone plan (excludes business and data-only plans).Auto Pay & paper-free billing req’d. Mobile + Home Discount enrollment req’d. $99 setup and other terms apply. Availability varies. Subject to credit approval. Wired and wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com/yourspeed for more info.<b> 3-year price lock guarantee:</b> For new Verizon Home Internet ("VHI") households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts or promotion, plan perk and any other third-party services.')
            }
            else if(prdId === 'R3583'){
                arrPromotions?.push('<p><b>Fios:</b> Fios ' +prdName+' plan at $' +parseInt(cprdPrice)+'/mo when combined with postpaid Verizon mobile phone plan (excludes business and data-only plans).Auto Pay & paper-free billing req’d. Mobile + Home Discount enrollment  req’d. $99 setup and other terms may apply. Availability varies. Subject to credit approval. Gigabit network connection to your home. Wired speeds up to 940/880 Mbps with avg. speeds between 750-940 Mbps download / 750-880 Mbps upload. Wired and wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com/yourspeed for more info.<b> 5-year price lock guarantee:</b> For new Verizon Home Internet ("VHI") households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts or promotion, plan perk and any other third-party services.')
            }
            else if(prdId === 'R3582'){
                arrPromotions?.push('<p><b>Fios:</b> Fios ' +prdName+' plan at $' +parseInt(cprdPrice)+'/mo when combined with postpaid Verizon mobile phone plan (excludes business and data-only plans).Auto Pay & paper-free billing req’d. Mobile + Home Discount enrollment  req’d. $99 setup and other terms may apply. Availability varies. Subject to credit approval. 2 Gigabit network connection to your home. Average wired download and upload speeds between 1.5 Gbps and 2.3 Gbps. Wired and wireless speeds may vary due to device limits, multiple users, network & other factors. See Verizon.com/yourspeed for more info. <b>5-year price lock guarantee:</b> For new Verizon Home Internet ("VHI") households who have not subscribed to a VHI service within the last 90 days. Applies only to the then-current base monthly rate exclusive of any other setup and additional equipment charges, discounts or promotion, plan perk and any other third-party services.')
            }
        }
        let perkCredit=this.props.buildProductState?.internet?.m2mPlans?.[0]?.specialOffers?.find((offer=>offer?.OfferText ==='Mobile + Home Perk Credit'))?.OfferText;
        let perkCreditEc=this.props.cart.cartResponse?.tierContent?.[0]?.sections.section?.filter(section=>section.sectionName === 'Promotions')?.[0]?.subSections.subSection?.[0].promos?.find(promo=>promo.promoText==='Mobile + Home Perk Credit')
        if((perkCreditEc?.promoText==='Mobile + Home Perk Credit') && (prdId === 'R3582' || prdId==='R3583' || prdId==='R3584' || prdId==='R3585'||prdId==='R3586' || prdId ==='R3587' || prdId ==='P5880')){
            arrPromotions.push('<p><b>Perk On Us Credit:</b>Requires one paid perk on eligible Verizon mobile phone line or eligible home internet plan. Up to $10/month credit will be applied to your Fios Internet bill as long as one paid perk remains active on either account. Perk credit canceled if paid perk removed, mobile line or home internet plan canceled, or home internet moved to ineligible plan. Perk promotional offers are not eligible for the perk discount. Credit applied in 1-2 billing cycles.');
        }

        
        const vzFwdDiscountOffer = promotionList?.find(promo=> promo?.includes("OF10043010") || promo?.includes("OF10043361")) 
        const vzFwdCreditOffer = promotionList?.find(promo=> promo?.includes("OF10043059")) 
        const vzFwdNYOffer = promotionList?.find(promo=> promo?.includes("OF10043347")) 
        if(vzFwdDiscountOffer){
            const discountOffer=this.props.buildProductContent[vzFwdDiscountOffer?.includes('~') ? "PR10009018~OF10043059":"OF10043059"]?.disclaimer?.split("\n")?.[0]
            arrPromotions.push(discountOffer+"\n");  
         }
         if(vzFwdNYOffer){
            const NYDiscountOffer=this.props.buildProductContent[vzFwdNYOffer?.includes('~') ? "PR10009018~OF10043059":"OF10043059"]?.disclaimer?.split("\n")?.[2]
            arrPromotions.push(NYDiscountOffer+"\n"); 
         }
        if(vzFwdCreditOffer){
            const creditOffer=this.props.buildProductContent[vzFwdCreditOffer?.includes('~') ? "PR10009018~OF10043059":"OF10043059"]?.disclaimer?.split("\n")?.[1]
            arrPromotions.push(creditOffer+"\n");
         }
         console.log(vzFwdDiscountOffer,vzFwdCreditOffer,this.props,'vzfwdDisclaimer', arrPromotions);
            if (arrPromotions.length > 0) {
                arrPromotions.forEach(function (val) {
                    promotionDisclaimer += val;
                });
            }
        }
        if (rewardOffer.length > 0) {
            rewardOffer.forEach(promo => {
                if (InHomeUtils.isNotNull(this.props.buildProductContent[promo]) && InHomeUtils.isNotEmpty(this.props.buildProductContent[promo].disclaimer)) {
                    if (promo === STUDENT_DISCOUNT_PROMO) {
                        const studentDisclaimer = this.getStudentDisclaimer(promo) || this.props.buildProductContent?.[promo]?.disclaimer;
                        arrRewardOffers.push(studentDisclaimer);
                    } else {
                        arrRewardOffers.push(this.props.buildProductContent?.[promo]?.disclaimer);
                    }
                }
            });
            if (arrRewardOffers.length > 0) {
                arrRewardOffers.forEach(function (val) {
              //if(val.indexOf("<b>Fios:</b>") == -1){
                    rewardsDisclaimer += val;
                //}
                });
            }
        }

        try {
            if (fcpProductLists.length > 0 && InHomeUtils.isNotNull(this.props) && InHomeUtils.isNotNull(this.props.productsDisclaimer) && !hoaFlow) {
                fcpProductLists.forEach(fcpProd => {
                    if (InHomeUtils.isNotEmpty(fcpProd)) {
                        // ITT-686322 :: Manoj :: showing new content for NOREWARDS scenario for baltimore and pittsburg dma
                        if (this.props.buildProductState?.internet?.selectedProduct &&
                            (!this.props.buildProductState?.internet?.selectedProduct.specialOffers ||
                            this.props.buildProductState?.internet?.selectedProduct.specialOffers?.length === 0) &&
                            this.props.productsDisclaimer[fcpProd + '_NOREWARDS']) {
                                fcpProd = fcpProd + '_NOREWARDS';
                        }
                        if (InHomeUtils.isNotNull(this.props.productsDisclaimer[fcpProd]) && InHomeUtils.isNotEmpty(this.props.productsDisclaimer[fcpProd].disclaimer)) {
                            if (this.props.cart.iONTEligibleAmazon != "undefined" && !this.props.cart.iONTEligibleAmazon && (this.props.internetProductContent && this.props.internetProductContent.mnhSignupIndicator !== 'Y')){
                                let fcpProdSplt = fcpProd.split('_')
                                if(fcpProd=='Fios_Five'){
                                    fcpProdSplt[0] = fcpProd
                                }
                                // arrFcpProduct.push(this.props.productsDisclaimer[fcpProdSplt[0]].disclaimer);
                                if (!this.props.loopQual.isFCPflow || this.props.appState?.flowType == "AF"){
                                    arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);
                                }
                                else {
                                    if (rewardsDisclaimer.indexOf("<b>Fios:</b> Offer valid thru 6.30.23 for eligible new res. custs") == -1){
                                    arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);

                                    // if(rewardsDisclaimer.indexOf("<p><b>Disney+ Premium (No Ads):</b> Offer valid for eligible new Verizon Home Internet Fios 1 gig") == -1){
                                    //     arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);

                                    // }
                                    }
                                }
                            }
                            else {
                                if((!this.props.loopQual.isFCPflow || this.props.appState?.flowType == "AF") && (this.props.internetProductContent && this.props.internetProductContent.mnhSignupIndicator !== 'Y')){
                                    arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);
                                }
                                else{
                                    if(rewardsDisclaimer.indexOf("<b>Fios:</b> Offer valid thru 6.30.23 for eligible new res. custs") == -1){
                                        arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);  
                                    }
                                }
                            
                                // if(disneyOnProfile) {
                                //     arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer)
                                // }
                            }
                        
                        
                        }
                    }
                });
            }

            // if(rewardsDisclaimer.indexOf("<p><b>Disney+ Premium (No Ads):</b> Offer valid for eligible new Verizon Home Internet Fios 1 gig") == -1){
            //                     arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);

            //                 }
                if (fcpEquipProductLists.length > 0 && InHomeUtils.isNotNull(this.props) && InHomeUtils.isNotNull(this.props.productsDisclaimer) && !hoaFlow) {
                fcpEquipProductLists.forEach(fcpProd => {
                    if (InHomeUtils.isNotEmpty(fcpProd)) {
                        if (InHomeUtils.isNotNull(this.props.productsDisclaimer[fcpProd]) && InHomeUtils.isNotEmpty(this.props.productsDisclaimer[fcpProd].disclaimer)) {
                            arrFcpProduct.push(this.props.productsDisclaimer[fcpProd].disclaimer);
                        }
                    }
                });
            }
            
            if (!isIONT && isMnhDiscountEligible && mnhSignupIndicator && this.props.buildProductState.internet?.selectedProduct) {
                let cartSelectedInternet = this.props.buildProductState.internet?.selectedProduct.speedCode;
                mobileDisclaimers=this.props.productsDisclaimer[cartSelectedInternet+"_MOBILE"].disclaimer;   
            }
            else if (isIONT && isMnhDiscountEligible && mnhSignupIndicator && this.props.buildProductState.internet?.selectedProduct) {
                let cartSelectedInternet = this.props.buildProductState.internet?.selectedProduct.speedCode;
                mobileDisclaimers=this.props.productsDisclaimer[cartSelectedInternet+"_MOBILE_IONT"].disclaimer;   
            }
            else if(isMnhDiscountEligible && (this.props.internetProductContent && this.props.internetProductContent?.mnhSignupIndicator === "Y") && arrFcpProduct.length > 0) {
                if(isDisclaimerPresent){
                    arrFcpProduct.forEach(function (val) {
                        fcpProductDisclaimer += val;
                    });
                }
            }
            else if(isMnhDiscountEligible && (this.props.internetProductContent && this.props.internetProductContent.mnhSignupIndicator === "") && arrFcpProduct.length > 0) {
                if(isDisclaimerPresent){
                arrFcpProduct.forEach(function (val) {
                    fcpProductDisclaimer += val;
                });
                }
            }
            else if(!isMnhDiscountEligible && arrFcpProduct.length > 0) {
                if(isDisclaimerPresent){
                    arrFcpProduct.forEach(function (val) {
                        fcpProductDisclaimer += val;
                    });
                }
                
            }   
        } catch (ex) {

        }
        // if(disneyProfileDisclaimer && disneyOnProfile) {
        //     profileDisneyDisclaimer=this.props.buildProductContent["PR10008322~OF10042197"].disclaimer;
        // } 
        if(internetOnProfile)
        {
            profileInternetDisclaimer = this.props.productsDisclaimer["941"].disclaimer;
        }
        const openHSTS = (e) => {
            window.open("https://www98.verizon.com/about/terms-conditions/home-security-terms-of-service");
        }
        if(isHomeSecuirtyAdded){
            /*homeSecurityDesc = <p><b>Home Security Service Details</b><br/><br/>Home Security automatically renews monthly at $4.99/ mo. unless canceled. Home Security Plus automatically renews monthly at $12.99/ mo. unless canceled. <br/><br/>

            Billing for your monthly, recurring fees for your Home Security or Home Security Plus service will begin automatically on the earlier of (i) the date your Home Security or Home Security Plus service is activated or (ii) seven (7) days after we ship you the video doorbell and outdoor camera equipment required for your Home Security or Home Security Plus service. Billing will continue until your Home Security or Home Security Plus service is canceled or terminated in accordance with the <a onClick={(e) => {openHSTS()}}>Home Security and Home Security Plus terms of service</a> or the terms of service applicable to your Verizon Home Internet service.<br/><br/>
            
            Your Home Security or Home Security Plus subscription is subject to the terms of service applicable to your Verizon Home Internet service and the <a onClick={(e) => {openHSTS()}}>Home Security and Home Security Plus terms of service</a>.<br/><br/>
            
            90 days after we ship your video doorbell and/ or outdoor camera equipment to you, we will
            automatically cancel your Home Security or Home Security Plus service if you haven’t already installed and set up the equipment and activated the service. You are responsible for all charges and fees related to your Home Security or Home Security Plus service, including equipment charges, incurred through the date of such automatic cancellation, and any charges or fees you paid for the service or equipment related to the service prior to the date of such automatic cancellation are not refundable. You will need to re-order Home Security or Home Security Plus for your Fios account if you want to sign up for it after the service has been canceled.<br/><br/>
            
            Home Service and Home Security Plus include devices capable of recording audio and/ or video. The recording of audio and video is subject to federal, state and local laws which may require you to provide notice of audio and video recording. Laws or regulations may require that any device which takes visual and/ or audio recordings be installed at such an angle
            that it does not take any recordings beyond the boundary of your property. You are responsible to ensure your use of these devices complies with applicable law. We are not responsible for you using any devices capable of recording audio and/ or video in connection with Home Security or Home Security Plus in a way that breaks the law.<br/><br/>
            
            Home Security and Home Security Plus do not provide third-party monitored security or alarm-system services. Home Security and Home Security Plus are not third-party monitored emergency notification or alarm-system services. Home Security and Home Security Plus do not monitor emergency notifications and will not dispatch emergency authorities to your home in the event of an emergency. Home Security and Home Security Plus do not include central station monitoring or systems that communicate directly or indirectly with public safety/first responders to request a police or fire department response. Verizon makes no warranty or representation that use of the services will affect or increase any level of safety. Home Security and Home Security Plus are not a substitute for a third-party monitored emergency notification system. All life-threatening, safety, and emergency events should be directed to the appropriate response services.
            </p>*/
        } 
        if(isHomeSecurePlusAdded){
           /* homeSecureplusDesc= <p><b>Digital Secure Home Plus</b><br/><br/>Digital Secure Home Plus automatically renews monthly at $5.99/mo. unless canceled. <br/><br/>

            Digital Secure Home Plus automatically renews monthly at $5.99/mo. unless cancelled.<br/><br/>
            
            Billing for your monthly, recurring fees for Digital Secure Home Plus begins automatically when you complete your order.<br/><br/>
            
            Verizon Fios Home Internet plan with a supported router model and the Verizon Home app required. Separate charges apply to your Fios Internet plan and equipment per your plan's terms of service.<br/><br/>
            
            You must download and use the Verizon Home App to activate and manage the Digital Secure Home Plus features.  Download the Verizon Home app at no charge from the Apple® App Store® or Google Play Store™.<br/><br/>
            </p>*/


        }
         if(isHomeSecureAdded){
            homeSecureDesc=<p><b>Digital Secure Home</b><br/><br/>Verizon Fios Home Internet plan with a supported router model and the Verizon Home app required. Separate charges apply to your Fios Internet plan and equipment per your plan's terms of service.<br></br>

            You must download and use the Verizon Home App to activate and manage the Digital Secure Home features.  Download the Verizon Home app at no charge from the Apple® App Store® or Google Play Store™. <br></br>
            </p> 

        }

        return (
            <div className='disclaimer-content'>
                {ReactHtmlParser(fcpProductDisclaimer)}
                {ReactHtmlParser(profileInternetDisclaimer)}
                {ReactHtmlParser(mobileDisclaimers)}
                {ReactHtmlParser(rewardsDisclaimer)}
                {ReactHtmlParser(promotionDisclaimer)}
                {ReactHtmlParser(channelDisclaimer)}
                {ReactHtmlParser(streamTvDisclaimer)}
                {ReactHtmlParser(profileDisneyDisclaimer)}
                {ReactHtmlParser(youTubeTVDisclaimer)}
                {ReactHtmlParser(slingTVDisclaimer)}
                {ReactHtmlParser(tvDisclaimer)}
                {ReactHtmlParser(routerDisclaimer)}
                {ReactHtmlParser(internetDisclaimer)}
                {ReactHtmlParser(voiceDisclaimer)}
                {homeSecurityDesc}
                {homeSecureplusDesc}
                {homeSecureDesc}

                
            </div>
        )
    }
}

export default promoDisclaimer;
